const allOption = {
	value: '',
	label: 'All',
	key: 'All',
};

const durationFilterOptions = [
	allOption,
	{ value: '1h', label: 'Last 1 Hour' },
	{ value: '24h', label: 'Last 24 Hours' },
	{ value: '7d', label: 'Last 7 Days' },
];

const alertStatusOptions = [
	{ value: 'breached', label: 'Breached' },
	{ value: 'not_breached', label: 'Not Breached' },
];

export { allOption, durationFilterOptions, alertStatusOptions };
